import { PlayIcon } from '@heroicons/react/20/solid';
import { Modal } from '@components/common';
import { useState } from 'react';
import { useExtendedRouter } from '@hooks/next-routing-wrappers';
import { SwiperStoriesCards } from '@components/templates/stories/SwiperStoriesCards';

interface StoriesBadgeVideoProps {
  slug: string | undefined;
  isAuthenticated: boolean;
  openTalentModal?: (userSlug: string, as?: string) => void,
}

export const StoriesBadgeVideo = ({ slug = '', isAuthenticated, openTalentModal }: StoriesBadgeVideoProps) => { // Translation
  const [openSingleStoriesModal, setOpenSingleStoriesModal] = useState<boolean>(false);
  const { locale, router } = useExtendedRouter();

  const onClose = () => {
    setOpenSingleStoriesModal(false);
  };


  // Render component
  // *****************************************
  return (
    <>

      <div
        className="absolute inset-0 flex w-full cursor-pointer items-center justify-center rounded-full py-0.5 text-pico font-medium  text-white shadow-xs"
      >
        <div
          role="presentation"
          onClick={() => {
            if (!isAuthenticated) {
              router.push('/login');
            } else {
              setOpenSingleStoriesModal(!openSingleStoriesModal);
            }
          }}
          className="absolute flex size-full items-center justify-center rounded-full border-2 border-pink bg-surface/20"
        >
          <PlayIcon className="size-7 shrink-0" />
        </div>

      </div>


      <Modal
        isOpen={openSingleStoriesModal}
        size="sm"
        body={(
          <SwiperStoriesCards
            locale={locale}
            openTalentModal={openTalentModal}
            slug={slug}
            onClose={onClose}
          />
        )}
        onClose={() => setOpenSingleStoriesModal(false)}
      />
    </>

  );
};
